import {roamingInvoiceFormExecutorOrCustomer} from "./hoc/roamingInvoiceFormExecutorOrCustomer";

const RoamingConstructionInvoiceExecutorForm = roamingInvoiceFormExecutorOrCustomer('RoamingConstructionInvoiceExecutorForm')
export default RoamingConstructionInvoiceExecutorForm
